export default {
  ext_id: {
    label: 'Product ID',
    required: true,
    valueKeys: ['$set', 'ext_id'],
    filters: ['trim', 'uppercase'],
    validators: [
      {
        validator: 'isExistyAndNotEmptyString',
        type: 'pre',
        params: [],
        alertCode: 'product-id-invalid',
        alertLevel: 'critical',
      },
    ],
  },
  // brand: {
  //   label: 'Brand',
  //   required: false,
  //   valueKeys: ['$set', 'brand'],
  //   filters: ['trim', 'uppercase'],
  //   validators: [
  //     // {
  //     //   validator: 'isExistyAndNotEmptyString',
  //     //   type: 'pre',
  //     //   params: [],
  //     //   alertCode: 'brand-invalid',
  //     //   alertLevel: 'critical',
  //     // },
  //   ],
  //   // lookup: {
  //   //   mapper: '',
  //   // },
  // },
  idh: {
    label: 'SKP IDH#',
    required: false,
    valueKeys: ['$set', 'idh'],
    filters: ['trim', 'uppercase'],
    validators: [],
  },
  n: {
    label: 'Product Name',
    required: true,
    valueKeys: ['$set', 'n'],
    filters: ['trim'],
    validators: [
      {
        validator: 'isExistyAndNotEmptyString',
        type: 'pre',
        params: [],
        alertCode: 'product-name-invalid',
        alertLevel: 'critical',
      },
    ],
  },
  price: {
    label: 'Wholesale Price',
    required: false,
    valueKeys: ['$set', 'price'],
    filters: ['money'],
    validators: [
      {
        validator: 'isMoneyDecimal',
        type: 'pre',
        params: [],
        alertCode: 'product-price-invalid',
        alertLevel: 'critical',
      },
    ],
  },
  ext_product_family: {
    label: 'Product Family',
    required: false,
    valueKeys: ['$set', 'data.family'],
    filters: ['trim'],
    validators: [],
  },
  ext_product_category: {
    label: 'Product Category',
    required: false,
    valueKeys: ['$set', 'data.cat_l1'],
    filters: ['trim'],
    validators: [],
  },
  ext_product_subcategory: {
    label: 'Product Subcategory',
    required: false,
    valueKeys: ['$set', 'data.cat_l2'],
    filters: ['trim'],
    validators: [],
  },
  desc: {
    label: 'Product Description',
    required: false,
    valueKeys: ['$set', 'desc'],
    filters: ['trim'],
    validators: [],
  },
};



// WEBPACK FOOTER //
// ./src/configs/etl/products/productsColumnsConfig.js